import React from 'react';
import { useWebMCP } from 'usewebmcp';
import { executeInstallPlugin } from './executors/installPlugin';

export const InstallPluginTool: React.FC = () => {
  useWebMCP({
    name: 'install_plugin',
    description:
      'Get the Figma Community install link for Color Scales I/O. Use when someone wants to install the plugin or needs the official Figma Community URL for contrast-first color scale generation in Figma.',
    annotations: { readOnlyHint: true },
    execute: executeInstallPlugin,
  });

  return null;
};
